import script from "./SelectColor.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectColor.vue?vue&type=script&setup=true&lang=js"

import "./SelectColor.vue?vue&type=style&index=0&id=7549b408&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.2.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7549b408"]])

export default __exports__